import React, { createRef, CSSProperties, PropsWithChildren } from 'react';
import { Tooltip } from '../Tooltip';
import css from './index.module.scss';

interface OverflowTextProps {
  className?: string;
  style?: CSSProperties;
  persistDelay?: React.ComponentProps<typeof Tooltip>['persistDelay'];
  variant?: React.ComponentProps<typeof Tooltip>['variant'];
}
interface OverflowTextState {
  needsTooltip: boolean;
}
export class OverflowText extends React.PureComponent<
  PropsWithChildren<OverflowTextProps>,
  OverflowTextState
> {
  private ref = createRef<HTMLDivElement>();
  constructor(props: OverflowTextProps) {
    super(props);
    this.state = {
      needsTooltip: false,
    };
  }
  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }
  componentDidUpdate() {
    this.onResize();
  }
  onResize = () => {
    if (
      this.ref.current &&
      this.ref.current.offsetWidth < this.ref.current.scrollWidth &&
      !this.state.needsTooltip
    ) {
      this.setState({
        needsTooltip: true,
      });
    } else if (
      this.ref.current &&
      this.ref.current.offsetWidth >= this.ref.current.scrollWidth &&
      this.state.needsTooltip
    ) {
      this.setState({
        needsTooltip: false,
      });
    }
  };
  render() {
    const overflowText = (
      <div ref={this.ref} className={css.overflowText}>
        {this.props.children}
      </div>
    );
    return (
      <div data-component="OverflowText" className={this.props.className} style={this.props.style}>
        {!this.state.needsTooltip ? (
          overflowText
        ) : (
          <Tooltip
            placement="bottom"
            tooltipContent={this.props.children}
            variant={this.props.variant ?? 'light'}
            maxWidth={530}
            persistDelay={this.props.persistDelay ?? 0}
          >
            {overflowText}
          </Tooltip>
        )}
      </div>
    );
  }
}
